module.exports = __webpack_public_path__ + "static/media/k1-compressed.c814d376.jpg";